<template>
  <div class="text-primary l-h-22 grey">
    <h5>We will cover all your regulatory compliance needs</h5>
    <h5>CDISC Explained</h5>
    <p>
      Clinical Data Interchange Standards Consortium (CDISC) is a global not-for-profit
      organization that determines data standards in the pharmaceutical industry based on
      the experience and knowledge of volunteers (with relevant education/skills).
      These standards are implemented during the analysis, reporting, and regulatory
      submission of medical data.
    </p>
    <p class="pb-3">
      The major standards supported by CDISC are SDTM (Study Data Tabulation Model) and ADaM
      (Analysis Data Model). The former accepts raw study data mapping and collating, while
      the latter works with analysis data. STATECS team is highly experienced in mapping
      all CDISC standards.
    </p>
    <p>
      There are a lot of benefits to complying with the CDISC standards:
    </p>
    <ul class="ml-4">
      <li>
        Medical research transparency
      </li>
      <li>
        Timeline and cost reduction during drug development
      </li>
      <li>
        FDA reviewers spend less time on the data reviewal thanks to these standards
      </li>
      <li>
        Easier exchange of high-quality data between sponsors and CROs
      </li>
    </ul>
    <div class="card-ctx float-right">
      <p>
        Our CDISC services include:
      </p>
      <ul class="ml-4">
        <li>
          Customized CDISC solutions
        </li>
        <li>
          Production of databases that are compliant with CDISC standards
        </li>
        <li>
          CDISC SDTM domain creation
        </li>
        <li>
          Clinical study mapping to CDISC standards for successful FDA submission as well
          as ISS/ISE reporting
        </li>
        <li>
          Ensuring the compatibility with SDTM & ADaM regardless of the version at hand
        </li>
        <li>
          CDISC ODM XML to SAS® datasets conversion and vice versa
        </li>
      </ul>
      <p>
        We will help you determine which data structures to convert to, when, and why. Our expertise
        lets us make the most of all the data collected as a result of various clinical trials.
        Choosing us you choose a customer-oriented policy, human-centered approach, high-quality
        services, and trustful and reliable collaboration.
      </p>
    </div>
    <b-card-title
      class="title text-primary font-weight-bold f-s-22 l-s-0"
      style="left: 30%"
    >
      {{ modalItem.title }}
    </b-card-title>
  </div>
</template>

<script>
export default {
  name: 'CdiscCompliantMapping',
  props: {
    modalItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
